/**
 * This file makes it so axios requests with the exclusive flag are guaranteed to be the only request in flight at a time.
 */

// @ts-nocheck
import axios from 'axios'

let inFlightCount = 0
let runningExclusiveRequest = false
const requestQueue = []

function processQueue() {
  while (requestQueue.length > 0) {
    if (runningExclusiveRequest) return
    if (inFlightCount > 0 && requestQueue[0].config.exclusive) return

    const { config, resolve } = requestQueue.shift()
    runningExclusiveRequest = config.exclusive
    inFlightCount++
    resolve(config)
  }
}

axios.interceptors.request.use((config) => {
  return new Promise((resolve) => {
    requestQueue.push({ config, resolve })
    processQueue()
  })
})

function requestDone() {
  inFlightCount--
  runningExclusiveRequest = false
  processQueue()
}

axios.interceptors.response.use(
  (response) => {
    requestDone()
    return response
  },
  (error) => {
    requestDone()
    return Promise.reject(error)
  }
)

export default axios
